"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.track = exports.forwardParams = exports.setLogger = exports.initializeAnalytics = exports.getUtmSource = exports.eventTypes = void 0;
var analytics_1 = __importDefault(require("analytics"));
var google_analytics_1 = __importDefault(require("@analytics/google-analytics"));
var google_tag_manager_1 = __importDefault(require("@analytics/google-tag-manager"));
var analytics_plugin_original_source_1 = __importStar(require("analytics-plugin-original-source"));
var v4_1 = __importDefault(require("uuid/v4"));
var logger_1 = require("../logger");
var TRACKING_ID;
var TAG_ID;
var UTM_SOURCE;
var UTM_SOURCE_CACHE_KEY = 'UTM_SOURCE_CACHE_KEY';
var setWithExpiry = function (key, value, ttl) {
    var now = new Date();
    var item = {
        value: value,
        expiry: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
};
var getWithExpiry = function (key) {
    var itemStr = localStorage.getItem(key);
    if (!itemStr) {
        return null;
    }
    var item = JSON.parse(itemStr);
    var now = new Date();
    if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
    }
    return item.value;
};
exports.eventTypes = {
    CLICK: 'UserClick',
    INPUT_CHANGE: 'InputChange',
    REGISTRATION: 'Registration',
    CONVERSION: 'Conversion',
    SOURCES: 'Sources',
    SESSION: 'Session',
};
var actionTypes = {
    USER_NO_REGISTRATION: 'USER-NO-REGISTRATION',
    NEW_REGISTRATION_COMPLETED: 'NEW-REGISTRATION-COMPLETED',
    LOG_IN: 'LOG_IN',
    LOG_OUT: 'LOG_OUT',
};
var analyticSingleton;
var sessionId = (0, v4_1.default)();
var userData = {
    email: "NOT_REGISTERED@temporary-sendfx.com.au",
};
var userLogged;
var order = 1;
var gaData = {};
var isUnregistered;
var isRegistered;
var isLoggerEnabled;
var resolveClientIdPromise;
var loadClientIdPromise = new Promise(function (resolve) {
    resolveClientIdPromise = resolve;
});
var getClientId = function () { return loadClientIdPromise; };
var getUtmSource = function () {
    if (UTM_SOURCE) {
        return UTM_SOURCE;
    }
    var cachedUtm = getWithExpiry(UTM_SOURCE_CACHE_KEY);
    if (cachedUtm) {
        return cachedUtm;
    }
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('utm_source');
};
exports.getUtmSource = getUtmSource;
var getGoogleAnalyticsDedicatedQueryParameters = function () {
    var urlParams = new URLSearchParams(window.location.search);
    var ca = urlParams.get('CA');
    var clientId = urlParams.get('cid');
    var utmSource = urlParams.get('utm_source');
    return {
        ca: ca,
        clientId: clientId,
        utmSource: utmSource,
    };
};
var buildString = function (object, separator) {
    if (object === void 0) { object = {}; }
    if (separator === void 0) { separator = ';'; }
    return Object.entries(object)
        .reduce(function (acc, _a) {
        var prop = _a[0], value = _a[1];
        if (value) {
            acc.push("".concat(prop, ":").concat(value));
        }
        return acc;
    }, [])
        .join(separator);
};
var initializeAnalytics = function (_a) {
    var credentials = _a.credentials, credentialKey = _a.credentialKey, project = _a.project, enableLogger = _a.enableLogger;
    if (!credentials) {
        throw Error('credentials are mandatory');
    }
    if (!analyticSingleton) {
        TRACKING_ID = credentials.analytics[credentialKey] && credentials.analytics[credentialKey].uid;
        TAG_ID = credentials.tag[credentialKey] && credentials.tag[credentialKey] && credentials.tag[credentialKey][project].uid;
        var plugins = [
            !!TRACKING_ID &&
                (0, google_analytics_1.default)({
                    // enforce NO DEBUGGING
                    debug: false,
                    trackingId: TRACKING_ID,
                }),
            !!TAG_ID &&
                (0, google_tag_manager_1.default)({
                    containerId: TAG_ID,
                }),
            (0, analytics_plugin_original_source_1.default)(),
        ].filter(Boolean);
        var analytic = (0, analytics_1.default)({
            app: 'portal',
            plugins: plugins,
        });
        analyticSingleton = analytic;
        isLoggerEnabled = enableLogger;
        analyticSingleton.page();
        var _b = getGoogleAnalyticsDedicatedQueryParameters(), originalClientId_1 = _b.clientId, ca_1 = _b.ca, utmSource = _b.utmSource;
        UTM_SOURCE = utmSource;
        if (UTM_SOURCE) {
            setWithExpiry(UTM_SOURCE_CACHE_KEY, UTM_SOURCE, 60 * 60 * 1000); // 60 minutes
        }
        if (!UTM_SOURCE) {
            UTM_SOURCE = getWithExpiry(UTM_SOURCE_CACHE_KEY);
        }
        analytic.on('ready', function () {
            window.ga(function (tracker) {
                var clientId = tracker.get('clientId');
                gaData.clientId = originalClientId_1 || clientId;
                gaData.CA = ca_1;
                userData = __assign({}, userData);
                resolveClientIdPromise(gaData.clientId);
            });
        });
    }
};
exports.initializeAnalytics = initializeAnalytics;
var setLogger = function () {
    isLoggerEnabled = true;
};
exports.setLogger = setLogger;
// this is so we can enable logger in any env and track any issue.
if (typeof window !== 'undefined') {
    window.analytics = { setLogger: exports.setLogger };
}
var log = function (type, data) {
    if (isLoggerEnabled) {
        logger_1.logger.log("ANALYTICS - ".concat(type), data);
    }
};
var sendIdentify = function (email, data) {
    if (analyticSingleton) {
        analyticSingleton.identify(email, data);
    }
    log(email, data);
};
var sendEvent = function (type, data) { return __awaiter(void 0, void 0, void 0, function () {
    var clientId, thisData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getClientId()];
            case 1:
                clientId = _a.sent();
                thisData = __assign(__assign({}, data), { label: "".concat(data.label || '', ";clientId:").concat(clientId, ";CA:").concat(gaData.CA), value: order });
                if (analyticSingleton) {
                    analyticSingleton.track(type, thisData);
                }
                // this is so we can sort in GA
                order += 1;
                log(type, thisData);
                return [2 /*return*/];
        }
    });
}); };
var unregisteredUser = function () {
    if (!isUnregistered) {
        sendEvent(actionTypes.USER_NO_REGISTRATION, {
            category: exports.eventTypes.REGISTRATION,
            label: buildString({ temporaryEmail: userData.email, sessionId: sessionId }),
        });
        isUnregistered = true;
        sendIdentify(userData.email, userData);
    }
};
var sessionStarted = function () {
    if (!userLogged) {
        userLogged = true;
        sendEvent(actionTypes.LOG_IN, {
            category: exports.eventTypes.SESSION,
            label: buildString({ email: userData.email, sessionId: sessionId }),
        });
    }
};
var sessionFinish = function () {
    sendEvent(actionTypes.LOG_OUT, {
        category: exports.eventTypes.SESSION,
        label: buildString({ email: userData.email, sessionId: sessionId }),
    });
    // create a new session for the next log in
    userLogged = false;
    sessionId = (0, v4_1.default)();
    order = 1;
    userData = {
        email: "NOT_REGISTERED@temporary-sendfx.com.au",
    };
    isUnregistered = undefined;
    isRegistered = undefined;
};
var getSource = function () {
    var original = (0, analytics_plugin_original_source_1.getOriginalSource)();
    var landing = (0, analytics_plugin_original_source_1.getOriginalLandingPage)();
    return __assign(__assign({}, original), { landing: landing });
};
var registeredUser = function (_a) {
    var firstName = _a.firstName, lastName = _a.lastName, email = _a.email;
    if (!email) {
        throw Error('email is required');
    }
    if (!isRegistered) {
        isRegistered = true;
        var unregisteredInfo = __assign({}, userData);
        userData = {
            firstName: firstName,
            lastName: lastName,
            email: email,
        };
        if (isUnregistered) {
            sendEvent(actionTypes.NEW_REGISTRATION_COMPLETED, {
                category: exports.eventTypes.REGISTRATION,
                label: buildString({ email: userData.email, sessionId: sessionId }),
            });
            userData = __assign(__assign({}, userData), { newUser: true, oldUserInfo: unregisteredInfo });
        }
        sessionStarted();
        sendEvent(actionTypes.LOG_IN, {
            category: exports.eventTypes.SOURCES,
            label: buildString(__assign(__assign({}, getSource()), { email: email, sessionId: sessionId })),
        });
        sendIdentify(email, userData);
    }
};
var event = function (actionType, args) {
    if (!args.path || args.name === undefined || !actionType) {
        throw Error('path, name and eventName must be present to track an event');
    }
    var eventParam = __assign(__assign({}, args), { actionType: actionType });
    if (userData) {
        eventParam = __assign(__assign({}, eventParam), userData);
    }
    var data = {
        category: "".concat(actionType, ":").concat(eventParam.name),
        label: buildString({ email: eventParam.email, value: eventParam.value, sessionId: sessionId }),
    };
    var type = buildString({ path: eventParam.path, category: "".concat(actionType, ":").concat(eventParam.name) }, '-');
    log(type, data);
    sendEvent(type, data);
};
var forwardParams = function (urlToForward) {
    var urlParams = new URLSearchParams(window.location.search);
    var urlToForwardParams = new URLSearchParams();
    for (var _i = 0, _a = urlParams.entries(); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        urlToForwardParams.set(key, value);
    }
    if (UTM_SOURCE && !urlToForwardParams.get('utm_source')) {
        urlToForwardParams.set('utm_source', UTM_SOURCE);
    }
    var utmFromCache = getWithExpiry(UTM_SOURCE_CACHE_KEY);
    if (!UTM_SOURCE && !urlToForwardParams.get('utm_source') && utmFromCache) {
        urlToForwardParams.set('utm_source', utmFromCache);
    }
    var paramsString = urlToForwardParams.toString();
    return "".concat(urlToForward).concat(paramsString ? '/?' + paramsString : '');
};
exports.forwardParams = forwardParams;
/**
 * @deprecated Please use the new GTM data layer object {@link ./analytics}
 */
exports.track = {
    event: event,
    registeredUser: registeredUser,
    unregisteredUser: unregisteredUser,
    sessionFinish: sessionFinish,
    sessionStarted: sessionStarted,
};
exports.default = exports.initializeAnalytics;
//# sourceMappingURL=legacy.js.map